import { render, staticRenderFns } from "./copy_manage.vue?vue&type=template&id=0156329c&scoped=true"
import script from "./copy_manage.vue?vue&type=script&lang=js"
export * from "./copy_manage.vue?vue&type=script&lang=js"
import style0 from "./copy_manage.vue?vue&type=style&index=0&id=0156329c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0156329c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0156329c')) {
      api.createRecord('0156329c', component.options)
    } else {
      api.reload('0156329c', component.options)
    }
    module.hot.accept("./copy_manage.vue?vue&type=template&id=0156329c&scoped=true", function () {
      api.rerender('0156329c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/process/components/copy_manage/copy_manage.vue"
export default component.exports